import { render, staticRenderFns } from "./InvoiceTableDesktop.vue?vue&type=template&id=0e173468&scoped=true&"
import script from "./InvoiceTableDesktop.vue?vue&type=script&lang=js&"
export * from "./InvoiceTableDesktop.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=0e173468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e173468",
  null
  
)

export default component.exports